import { ChartNoAxesColumn, ScrollText } from 'lucide-react'

export function DashboardEmptyState(props: {
	description: string
	icon: 'chart' | 'logs'
	title: string
}) {
	const Icon = props.icon === 'chart' ? ChartNoAxesColumn : ScrollText

	return (
		<div className='dashboard-empty-state'>
			<span className='dashboard-empty-state__icon'>
				<Icon aria-hidden='true' />
			</span>
			<div>
				<p className='dashboard-empty-state__title'>{props.title}</p>
				<p className='dashboard-empty-state__description'>
					{props.description}
				</p>
			</div>
		</div>
	)
}
